import React, { PureComponent } from 'react';
import DefaultConfiguration from './DefaultConfiguration';
import { RESOURCE_TYPE_SOURCE, RESOURCE_TYPE_SINK } from 'js/constants/resourceTypes';
import {
  CONNECTION_CATEGORY_REST,
  CONNECTION_CATEGORY_FILE,
  CONNECTION_CATEGORY_DATABASE,
  CONNECTION_CATEGORY_WEBHOOK,
  CONNECTION_CATEGORY_SOAP,
  CONNECTION_CATEGORY_DATA_MAP,
  CONNECTION_CATEGORY_TEMPLATIZED_API,
  CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT,
  CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
  CONNECTION_CATEGORY_KAFKA,
  CONNECTION_CATEGORY_NEXLA_MONITOR,
  CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI,
} from 'js/constants/connectionCategories';
import APISourceConfigurationContainer from '../../data_sources/cards/configViews/APISourceConfigurationContainer';
import FileSourceConfiguration from '../../data_sources/cards/configViews/FileSourceConfiguration';
import DatabaseSourceConfiguration from '../../data_sources/cards/configViews/DatabaseSourceConfiguration';
import WebhookSourceConfigurationContainer from '../../data_sources/cards/configViews/WebhookSourceConfigurationContainer';
import SOAPSourceConfiguration from '../../data_sources/cards/configViews/SOAPSourceConfiguration';
import TemplatizedAPISourceConfiguration from '../../data_sources/cards/configViews/TemplatizedAPISourceConfiguration';
import TemplatizedScriptSourceConfigurationContainer from '../../data_sources/cards/configViews/TemplatizedScriptSourceConfigurationContainer';
import NexlaMonitorSourceConfiguration from '../../data_sources/cards/configViews/NexlaMonitorSourceConfiguration';

import EmailSourceConfiguration from '../../data_sources/cards/configViews/EmailSourceConfiguration';
import KafkaSourceConfiguration from '../../data_sources/cards/configViews/KafkaSourceConfiguration';

import FileSinkConfiguration from '../../data_sinks/cards/configViews/FileSinkConfiguration';
import DatabaseSinkConfiguration from '../../data_sinks/cards/configViews/DatabaseSinkConfiguration';
import APISinkConfiguration from '../../data_sinks/cards/configViews/APISinkConfiguration';
import DynamicDataMapConfiguration from '../../data_sinks/cards/configViews/DynamicDataMapConfiguration';
import KafkaSinkConfiguration from '../../data_sinks/cards/configViews/KafkaSinkConfiguration';
import TemplatizedAPISinkConfiguration from '../../data_sinks/cards/TemplatizedAPISinkConfiguration';
import ConfigurationFields from './ConfigurationFields';

class ConfigurationView extends PureComponent {
  _getConfigView = () => {
    const { connectionCategory, paging, ...otherProps } = this.props;
    let configView = null;
    if (this.props.entityType === RESOURCE_TYPE_SINK) {
      switch (connectionCategory) {
        case CONNECTION_CATEGORY_FILE:
          configView = <FileSinkConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_DATABASE:
          configView = <DatabaseSinkConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_REST:
          configView = <APISinkConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_DATA_MAP:
          configView = <DynamicDataMapConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_KAFKA:
          configView = <KafkaSinkConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT:
          configView = <TemplatizedScriptSourceConfigurationContainer {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_TEMPLATIZED_API:
          configView =
            otherProps.data.sink_config &&
            otherProps.data.sink_config.sink_type === 'rest' &&
            otherProps.data.sink_config.vendor_id ? (
              <APISinkConfiguration {...otherProps} configFields={paging.sinkConfigById.rest} />
            ) : (
              <TemplatizedAPISinkConfiguration {...otherProps} />
            );
          break;

        default:
          configView =
            otherProps.data.sink_config &&
            otherProps.data.sink_config.sink_type === 'rest' &&
            otherProps.data.sink_config.vendor_id ? (
              <APISinkConfiguration {...otherProps} configFields={paging.sinkConfigById.rest} />
            ) : (
              <DefaultConfiguration {...otherProps} />
            );
      }
    } else {
      switch (connectionCategory) {
        case CONNECTION_CATEGORY_FILE:
          configView = <FileSourceConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_DATABASE:
          configView = <DatabaseSourceConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_WEBHOOK:
          configView = <WebhookSourceConfigurationContainer {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_REST:
          configView = <APISourceConfigurationContainer {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_SOAP:
          configView = <SOAPSourceConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_TEMPLATIZED_API:
          configView =
            otherProps.data.source_config &&
            otherProps.data.source_config.advanced_templatized_api ? (
              <APISourceConfigurationContainer
                {...otherProps}
                configFields={paging.sourceConfigById.rest}
              />
            ) : (
              <TemplatizedAPISourceConfiguration {...otherProps} />
            );
          break;

        case CONNECTION_CATEGORY_NEXLA_MONITOR:
          configView =
            otherProps.data.source_config &&
            otherProps.data.source_config.advanced_templatized_api ? (
              <APISourceConfigurationContainer
                {...otherProps}
                configFields={paging.sourceConfigById.rest}
              />
            ) : (
              <NexlaMonitorSourceConfiguration {...otherProps} />
            );
          break;

        case CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT:
          configView = <TemplatizedScriptSourceConfigurationContainer {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT:
          configView = <EmailSourceConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_KAFKA:
          configView = <KafkaSourceConfiguration {...otherProps} />;
          break;

        case CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI:
          configView = (
            <ConfigurationFields {...otherProps} connectionCategory={connectionCategory} />
          );
          break;

        default:
          configView = <DefaultConfiguration {...otherProps} />;
      }
    }
    return configView;
  };

  render() {
    const renderContent = this._getConfigView();

    return <div>{renderContent}</div>;
  }
}

ConfigurationView.defaultProps = {
  entityType: RESOURCE_TYPE_SOURCE,
};

export default ConfigurationView;
